import {
  TRUSTED_SENDER_STATUS_NOT_CONFIRMED,
  TRUSTED_SENDER_STATUS_CONFIRMED,
  TRUSTED_SENDER_STATUS_BLOCKED,
  TRUSTED_SENDER_STATUS_DELIVER_OK,
  TRUSTED_SENDER_STATUS_DELIVER_WARN,
  TRUSTED_SENDER_STATUS_DELIVER_ERROR,
  TRUSTED_SENDER_STATUS_NO_DELIVER,
  TRUSTED_SENDER_STATUS_DELIVER_ISP
} from 'Api/beSendApi'
import {
  TRUSTED_EMAIL_INPUT_VARIANT_SUCCESS,
  TRUSTED_EMAIL_INPUT_VARIANT_UNVERIFIED,
  TRUSTED_EMAIL_INPUT_VARIANT_ERROR,
  TRUSTED_EMAIL_INPUT_VARIANT_WARNING,
  TRUSTED_EMAIL_INPUT_VARIANT_BLOCKED
} from 'mailup-web-components'

const mapStatusToVariant = (status, hideDelivStatus) => {
  switch (status) {
    case TRUSTED_SENDER_STATUS_NOT_CONFIRMED:
      return TRUSTED_EMAIL_INPUT_VARIANT_UNVERIFIED
    case TRUSTED_SENDER_STATUS_DELIVER_ERROR:
    case TRUSTED_SENDER_STATUS_DELIVER_ISP:
      return TRUSTED_EMAIL_INPUT_VARIANT_ERROR
    case TRUSTED_SENDER_STATUS_DELIVER_WARN:
      return hideDelivStatus
        ? TRUSTED_EMAIL_INPUT_VARIANT_SUCCESS
        : TRUSTED_EMAIL_INPUT_VARIANT_WARNING
    case TRUSTED_SENDER_STATUS_BLOCKED:
      return TRUSTED_EMAIL_INPUT_VARIANT_BLOCKED
    case TRUSTED_SENDER_STATUS_CONFIRMED:
    case TRUSTED_SENDER_STATUS_DELIVER_OK:
    case TRUSTED_SENDER_STATUS_NO_DELIVER:
      return TRUSTED_EMAIL_INPUT_VARIANT_SUCCESS
  }
}

export default mapStatusToVariant
